import React from 'react';
import { Navigate } from 'react-router';
import Base from '../Base';
import DatePicker from 'react-datepicker2';

export default class InvoiceGenrate extends Base {
    constructor(props) {
        super(props);
        this.state = {
            caller: props.Caller,
            type: props.Type,
            stuffSubUnitEnable: props.StuffSubUnitEnable,
            data: null,
            loading: false,
            fromDate: new Date().getFullYear() + "/" + (new Date().getMonth() + 1) + "/" + new Date().getDate(),
            toDate: new Date().getFullYear() + "/" + (new Date().getMonth() + 1) + "/" + new Date().getDate(),
            wichUnit: 1
        };
        this.keyDownFunction = this.keyDownFunction.bind(this);
    }
    componentWillUnmount() {
        this.removeKeyDown();
    }
    componentDidMount() {
        this.addKeyDown();
    }
    save() {
        this.httpPost('api/v1/factor/invoicegenerate', {
            type: this.state.type,
            wichUnit: this.state.wichUnit,
            fromDate: this.convertMomentToDb(this.state.fromDate),
            toDate: this.convertMomentToDb(this.state.toDate),
            facotrIds: []
        }).then((data) => {
            if (data.status === -1) window.location.href = '/login';
            if (data.status === 1) {
                this.showSuccessMessage('تعداد ' + data.record + ' صورتحساب صادر شد');
                this.state.caller.refreshData();
                this.closeMe();
            } else {
                this.showErorrMessage(data.message);
                this.setState({
                    loading: false,
                });
            }
        });
    }
    renderForm() {
        return <div className="modal fade listModal in show" tabIndex="-1" role="dialog">
            <div className="modal-backdrop fade in" style={{ "height": "100%" }} onClick={e => this.closeMe()}></div>
            <div className="modal-dialog ui-draggable">
                <div className="modal-content">
                    <div className="modal-body" style={{ "padding": "0" }}>
                        <div className="modal-header modal-header-info">
                            <button type="button" className="close" onClick={e => this.closeMe()} aria-label="Close"><span aria-hidden="true">×</span></button>
                            <h4 className="modal-title">صدور صورتحساب فاکتورهای قطعی </h4>
                        </div>
                        <div className="modal-body">
                            <div className="container-fluid">
                                <div className="row">
                                    <div className="col-sm-9">
                                        <div className="form-group">
                                            <label for="name" className="title1">از تاریخ:</label>
                                            <DatePicker
                                                inputReadOnly={false}
                                                className="form-input input-sm persian-date"
                                                placeholder={'تاریخ'}
                                                isGregorian={false}
                                                showTodayButton={true}
                                                timePicker={false}
                                                onChange={(e) => this.state.fromDate = e }
                                                value={this.getFormatedDateForDatePicker(this.state.fromDate)}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-sm-3">
                                        <div className="form-group">
                                            <label for="name" className="title1">تا تاریخ:</label>
                                            <DatePicker
                                                inputReadOnly={false}
                                                className="form-input input-sm persian-date"
                                                placeholder={'تاریخ'}
                                                isGregorian={false}
                                                showTodayButton={true}
                                                timePicker={false}
                                                onChange={(e) => this.state.toDate = e}
                                                value={this.getFormatedDateForDatePicker(this.state.toDate)}
                                            />
                                        </div>
                                    </div>
                                    {this.state.stuffSubUnitEnable === 2 && <div className="col-lg-12">
                                        <div className="form-group">
                                            <label className="form-label">واحد سنجش:</label>
                                            <select className="form-control" onChange={(e) => this.state.wichUnit = parseInt(e.target.value)} defaultValue={this.state.wichUnit}>
                                                <option value="1">استفاده از واحد اصلی</option>
                                                <option value="2">استفاده از واحد فرعی</option>
                                            </select>
                                        </div>
                                    </div>}
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-dim btn-outline-light" onClick={e => this.closeMe()}>انصراف</button>
                            <button type="submit" onClick={e => this.save(e)} className="btn btn-success">
                                صدور
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                this.getGlobalContainer(),
                this.renderForm()
            ];

        return contents;
    }
}